var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoPdlMx(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 503.74 139.55",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#radial-gradient-3);\n        mix-blend-mode: screen;\n      }\n\n      .cls-2 {\n        fill: #ffcd8a;\n      }\n\n      .cls-3 {\n        fill: url(#linear-gradient-8);\n      }\n\n      .cls-4 {\n        fill: url(#linear-gradient-7);\n      }\n\n      .cls-5 {\n        fill: url(#linear-gradient-5);\n      }\n\n      .cls-6 {\n        fill: url(#linear-gradient-6);\n      }\n\n      .cls-7 {\n        fill: url(#linear-gradient-9);\n      }\n\n      .cls-8 {\n        fill: url(#linear-gradient-4);\n      }\n\n      .cls-9 {\n        fill: url(#linear-gradient-3);\n      }\n\n      .cls-10 {\n        fill: #fff;\n        opacity: .51;\n      }\n\n      .cls-10, .cls-11 {\n        mix-blend-mode: overlay;\n      }\n\n      .cls-12 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-12, .cls-13, .cls-14, .cls-15, .cls-16 {\n        mix-blend-mode: multiply;\n      }\n\n      .cls-17 {\n        fill: #80ff00;\n      }\n\n      .cls-18 {\n        fill: url(#linear-gradient);\n      }\n\n      .cls-19 {\n        isolation: isolate;\n      }\n\n      .cls-13 {\n        fill: url(#linear-gradient-25);\n      }\n\n      .cls-14 {\n        fill: url(#linear-gradient-27);\n      }\n\n      .cls-15 {\n        fill: url(#linear-gradient-24);\n      }\n\n      .cls-20 {\n        fill: #f66;\n      }\n\n      .cls-11 {\n        fill: url(#radial-gradient);\n        opacity: .69;\n      }\n\n      .cls-21 {\n        fill: url(#linear-gradient-43);\n      }\n\n      .cls-22 {\n        fill: url(#linear-gradient-40);\n      }\n\n      .cls-23 {\n        fill: url(#linear-gradient-41);\n      }\n\n      .cls-24 {\n        fill: url(#linear-gradient-42);\n      }\n\n      .cls-25 {\n        fill: url(#linear-gradient-49);\n      }\n\n      .cls-26 {\n        fill: url(#linear-gradient-48);\n      }\n\n      .cls-27 {\n        fill: url(#linear-gradient-45);\n      }\n\n      .cls-28 {\n        fill: url(#linear-gradient-47);\n      }\n\n      .cls-29 {\n        fill: url(#linear-gradient-44);\n      }\n\n      .cls-30 {\n        fill: url(#linear-gradient-46);\n      }\n\n      .cls-31 {\n        fill: url(#linear-gradient-10);\n      }\n\n      .cls-32 {\n        fill: url(#linear-gradient-11);\n      }\n\n      .cls-33 {\n        fill: url(#linear-gradient-12);\n      }\n\n      .cls-34 {\n        fill: url(#linear-gradient-13);\n      }\n\n      .cls-35 {\n        fill: url(#linear-gradient-19);\n      }\n\n      .cls-36 {\n        fill: url(#linear-gradient-14);\n      }\n\n      .cls-37 {\n        fill: url(#linear-gradient-21);\n      }\n\n      .cls-38 {\n        fill: url(#linear-gradient-20);\n      }\n\n      .cls-39 {\n        fill: url(#linear-gradient-22);\n      }\n\n      .cls-40 {\n        fill: url(#linear-gradient-23);\n      }\n\n      .cls-41 {\n        fill: url(#linear-gradient-28);\n      }\n\n      .cls-42 {\n        fill: url(#linear-gradient-32);\n      }\n\n      .cls-43 {\n        fill: url(#linear-gradient-31);\n      }\n\n      .cls-44 {\n        fill: url(#linear-gradient-33);\n      }\n\n      .cls-45 {\n        fill: url(#linear-gradient-30);\n      }\n\n      .cls-46 {\n        fill: url(#linear-gradient-15);\n      }\n\n      .cls-47 {\n        fill: url(#linear-gradient-16);\n      }\n\n      .cls-48 {\n        fill: url(#linear-gradient-17);\n      }\n\n      .cls-49 {\n        fill: url(#linear-gradient-18);\n      }\n\n      .cls-50 {\n        fill: url(#linear-gradient-35);\n      }\n\n      .cls-51 {\n        fill: url(#linear-gradient-34);\n      }\n\n      .cls-52 {\n        fill: url(#linear-gradient-36);\n      }\n\n      .cls-53 {\n        fill: url(#linear-gradient-38);\n      }\n\n      .cls-54 {\n        fill: url(#linear-gradient-26);\n      }\n\n      .cls-55 {\n        fill: url(#linear-gradient-29);\n      }\n\n      .cls-56 {\n        fill: url(#linear-gradient-37);\n      }\n\n      .cls-57 {\n        fill: url(#linear-gradient-39);\n      }\n\n      .cls-58 {\n        fill: url(#linear-gradient-57);\n      }\n\n      .cls-59 {\n        fill: url(#linear-gradient-58);\n      }\n\n      .cls-60 {\n        fill: url(#linear-gradient-59);\n      }\n\n      .cls-61 {\n        fill: url(#linear-gradient-53);\n      }\n\n      .cls-62 {\n        fill: url(#linear-gradient-54);\n      }\n\n      .cls-63 {\n        fill: url(#linear-gradient-55);\n      }\n\n      .cls-64 {\n        fill: url(#linear-gradient-56);\n      }\n\n      .cls-65 {\n        fill: url(#linear-gradient-50);\n      }\n\n      .cls-66 {\n        fill: url(#linear-gradient-51);\n      }\n\n      .cls-67 {\n        fill: url(#linear-gradient-52);\n      }\n\n      .cls-68 {\n        fill: url(#linear-gradient-67);\n      }\n\n      .cls-69 {\n        fill: url(#linear-gradient-68);\n      }\n\n      .cls-70 {\n        fill: url(#linear-gradient-69);\n      }\n\n      .cls-71 {\n        fill: url(#linear-gradient-63);\n      }\n\n      .cls-72 {\n        fill: url(#linear-gradient-64);\n      }\n\n      .cls-73 {\n        fill: url(#linear-gradient-65);\n      }\n\n      .cls-74 {\n        fill: url(#linear-gradient-66);\n      }\n\n      .cls-75 {\n        fill: url(#linear-gradient-60);\n      }\n\n      .cls-76 {\n        fill: url(#linear-gradient-61);\n      }\n\n      .cls-77 {\n        fill: url(#linear-gradient-62);\n      }\n\n      .cls-78 {\n        fill: url(#linear-gradient-75);\n      }\n\n      .cls-79 {\n        fill: url(#linear-gradient-72);\n      }\n\n      .cls-80 {\n        fill: url(#linear-gradient-74);\n      }\n\n      .cls-81 {\n        fill: url(#linear-gradient-71);\n      }\n\n      .cls-82 {\n        fill: url(#linear-gradient-73);\n      }\n\n      .cls-83 {\n        fill: url(#linear-gradient-70);\n      }\n\n      .cls-16 {\n        fill: url(#radial-gradient-2);\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 338.88,
    y1: 89.81,
    x2: 309.59,
    y2: 57.77,
    gradientTransform: "translate(10.49 -48.8) rotate(7.18)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#930606"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#bf0606"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f21c1c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 364.95,
    y1: 102.37,
    x2: 337.53,
    y2: 71.98,
    gradientTransform: "translate(6.48 -57.66) rotate(8.87)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6a1a00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#8d3704"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#b25509"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#cb8d5a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#e1bda0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#f1e1d3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#fbf6f3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 427.29,
    y1: 47.53,
    x2: 373.09,
    y2: 47.53,
    gradientTransform: "translate(6.48 -57.66) rotate(8.87)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 385.98,
    y1: 10.18,
    x2: 419.74,
    y2: 10.18,
    gradientTransform: "translate(6.48 -57.66) rotate(8.87)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fcdc42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f9bb30"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 387.54,
    y1: 7.33,
    x2: 418.17,
    y2: 7.33,
    gradientTransform: "translate(6.48 -57.66) rotate(8.87)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3aa33a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#389f38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#349635"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#2e852f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#256e27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1e5b21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 389.3,
    y1: 4.52,
    x2: 416.4,
    y2: 4.52,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 361.81,
    y1: 87.57,
    x2: 443.81,
    y2: 87.57,
    gradientTransform: "translate(6.48 -57.66) rotate(8.87)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ddd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#fafafa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#ededed"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#d8d8d8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#bababa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#adadad"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 361.34,
    y1: 82.63,
    x2: 444.31,
    y2: 82.63,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 361.62,
    y1: 78.04,
    x2: 444.06,
    y2: 78.04,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 352.42,
    y1: 48.48,
    x2: 431.89,
    y2: 47.11,
    gradientTransform: "translate(10.49 -48.8) rotate(7.18)",
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 374.94,
    y1: 32.07,
    x2: 430.79,
    y2: 32.07,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 366.01,
    y1: 22.95,
    x2: 418.63,
    y2: 24.32,
    gradientTransform: "translate(10.49 -48.8) rotate(7.18)",
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 365.08,
    y1: 62.33,
    x2: 372.36,
    y2: 62.33,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 388.43,
    y1: 76.29,
    x2: 378.06,
    y2: 61.72,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 394.81,
    y1: 67.28,
    x2: 410.84,
    y2: 67.28,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 425.33,
    y1: 72.75,
    x2: 411.12,
    y2: 58.05,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: 367.39,
    y1: 54,
    x2: 369.38,
    y2: 54,
    gradientTransform: "translate(6.48 -57.66) rotate(8.87)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3aa33a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#389f38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#349635"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#2e852f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#256e27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1e5b21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: 375.04,
    y1: 59.24,
    x2: 378.22,
    y2: 59.24,
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: 391.22,
    y1: 62.21,
    x2: 395.29,
    y2: 62.21,
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: 410.99,
    y1: 62.21,
    x2: 415.23,
    y2: 62.21,
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: 433.53,
    y1: 62.32,
    x2: 440.61,
    y2: 62.32,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: 427.61,
    y1: 59.31,
    x2: 430.75,
    y2: 59.31,
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    x1: 436.26,
    y1: 54.35,
    x2: 438.26,
    y2: 54.35,
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 389.11,
    cy: 55.32,
    fx: 389.11,
    fy: 55.32,
    r: 14.91,
    gradientTransform: "translate(147.9 -382.66) rotate(23.27) scale(1 5.63)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-24",
    x1: 408.74,
    y1: 86.92,
    x2: 399.19,
    y2: 66.99,
    gradientTransform: "translate(6.48 -57.66) rotate(8.87)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6a1a00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#8d3704"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#b25509"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#cb8d5a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#e1bda0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#f1e1d3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#fbf6f3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-25",
    x1: 440.53,
    y1: 37.71,
    x2: 395.07,
    y2: 53.28,
    gradientTransform: "translate(6.48 -57.66) rotate(8.87)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b25509"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-26",
    x1: 495.74,
    y1: 113.61,
    x2: 438.93,
    y2: 77.79,
    gradientTransform: "translate(6.48 -57.66) rotate(8.87)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-2",
    cx: 438.43,
    cy: 79.56,
    fx: 438.43,
    fy: 79.56,
    r: 103.98,
    gradientTransform: "translate(-5.69 162.32) rotate(-13.3) scale(1 .35)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6a1700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#c40f00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#e90d00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#e90e01"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#f0625a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#f6a5a0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#fbd6d3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#fdf3f3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-27",
    x1: 423.01,
    y1: 80.07,
    x2: 445.24,
    y2: 101.32,
    gradientTransform: "translate(6.48 -57.66) rotate(8.87)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6a1700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#c40f00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#e90d00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#e90e01"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#f0625a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#f6a5a0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#fbd6d3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#fdf3f3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-28",
    x1: 290.76,
    y1: 75.56,
    x2: 511.58,
    y2: 75.56,
    gradientTransform: "translate(6.48 -57.66) rotate(8.87)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#930606"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#e51717"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#bf0606"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f21c1c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-29",
    x1: 244.35,
    y1: 49.85,
    x2: 539.51,
    y2: 93.32,
    gradientTransform: "translate(10.49 -48.8) rotate(7.18)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b25509"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#f4a22a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#d6742b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f9ba5d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-30",
    x1: 229.27,
    y1: 62.88,
    x2: 498.34,
    y2: 78.13,
    gradientTransform: "translate(10.49 -48.8) rotate(7.18)",
    xlinkHref: "#linear-gradient-28"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-31",
    x1: 313.3,
    y1: 55.46,
    x2: 313.54,
    y2: 55.46,
    gradientTransform: "translate(6.48 -57.66) rotate(8.87)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b25509"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#d6742b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f9ba5d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-32",
    x1: 313.07,
    y1: 55.48,
    y2: 55.48,
    xlinkHref: "#linear-gradient-31"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-33",
    x1: 277.74,
    y1: 15.94,
    x2: 470.54,
    y2: 94.95,
    xlinkHref: "#linear-gradient-29"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-3",
    cx: 371.76,
    cy: 8.16,
    fx: 371.76,
    fy: 8.16,
    r: 45.4,
    gradientTransform: "translate(6.48 -57.66) rotate(8.87)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f9ba5d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-34",
    x1: 294.58,
    y1: 63.78,
    x2: 302.68,
    y2: 63.78,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-35",
    x1: 294.52,
    y1: 75.81,
    x2: 299.83,
    y2: 75.81,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-36",
    x1: 299.16,
    y1: 86.48,
    x2: 310,
    y2: 86.48,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-37",
    x1: 310,
    y1: 91.09,
    x2: 322.43,
    y2: 91.09,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-38",
    x1: 322.43,
    y1: 93.43,
    x2: 335.35,
    y2: 93.43,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-39",
    x1: 335.35,
    y1: 94.14,
    x2: 348.39,
    y2: 94.14,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-40",
    x1: 348.39,
    y1: 93.85,
    x2: 361.4,
    y2: 93.85,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-41",
    x1: 361.4,
    y1: 92.69,
    x2: 374.26,
    y2: 92.69,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-42",
    x1: 374.26,
    y1: 90.46,
    x2: 386.89,
    y2: 90.46,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-43",
    x1: 386.89,
    y1: 87.26,
    x2: 399.23,
    y2: 87.26,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-44",
    x1: 399.23,
    y1: 83.15,
    x2: 411.1,
    y2: 83.15,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-45",
    x1: 411.1,
    y1: 78.53,
    x2: 422.81,
    y2: 78.53,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-46",
    x1: 422.81,
    y1: 73.67,
    x2: 434.37,
    y2: 73.67,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-47",
    x1: 434.37,
    y1: 68.51,
    x2: 445.76,
    y2: 68.51,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-48",
    x1: 445.76,
    y1: 63.06,
    x2: 456.94,
    y2: 63.06,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-49",
    x1: 456.94,
    y1: 57.41,
    x2: 467.93,
    y2: 57.41,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-50",
    x1: 467.93,
    y1: 52.01,
    x2: 479.01,
    y2: 52.01,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-51",
    x1: 479.01,
    y1: 47.83,
    x2: 490.61,
    y2: 47.83,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-52",
    x1: 490.61,
    y1: 45.34,
    x2: 501.21,
    y2: 45.34,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-53",
    x1: 501.21,
    y1: 52.1,
    x2: 508.7,
    y2: 52.1,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-54",
    x1: 505.44,
    y1: 62.58,
    x2: 509.24,
    y2: 62.58,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-55",
    x1: 501.14,
    y1: 74.39,
    x2: 505.7,
    y2: 74.39,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-56",
    x1: 346.3,
    y1: 92.86,
    x2: 349.68,
    y2: 92.86,
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-57",
    x1: 334.55,
    y1: 92.39,
    x2: 337.54,
    y2: 92.39,
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-58",
    x1: 322,
    y1: 90.54,
    x2: 325,
    y2: 90.54,
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-59",
    x1: 310.79,
    y1: 86.41,
    x2: 313.23,
    y2: 86.41,
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-60",
    x1: 300.53,
    y1: 79.74,
    x2: 303.17,
    y2: 79.74,
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-61",
    x1: 296.25,
    y1: 69.8,
    x2: 298.14,
    y2: 69.8,
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-62",
    x1: 358.93,
    y1: 91.87,
    x2: 362.3,
    y2: 91.87,
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-63",
    x1: 371.26,
    y1: 89.82,
    x2: 374.64,
    y2: 89.82,
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-64",
    x1: 383.69,
    y1: 86.74,
    x2: 387.07,
    y2: 86.74,
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-65",
    x1: 395.34,
    y1: 83.04,
    x2: 398.72,
    y2: 83.04,
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-66",
    x1: 407.03,
    y1: 78.49,
    x2: 410.41,
    y2: 78.49,
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-67",
    x1: 418.52,
    y1: 73.95,
    x2: 421.89,
    y2: 73.95,
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-68",
    x1: 430.3,
    y1: 68.92,
    x2: 433.68,
    y2: 68.92,
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-69",
    x1: 441.3,
    y1: 63.52,
    x2: 444.67,
    y2: 63.52,
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-70",
    x1: 452.82,
    y1: 58,
    x2: 456.2,
    y2: 58,
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-71",
    x1: 463.91,
    y1: 52.31,
    x2: 467.28,
    y2: 52.31,
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-72",
    x1: 475.8,
    y1: 47.6,
    x2: 479.17,
    y2: 47.6,
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-73",
    x1: 488.19,
    y1: 44.6,
    x2: 490.89,
    y2: 44.6,
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-74",
    x1: 512.54,
    y1: -136.17,
    x2: 514.48,
    y2: -136.17,
    gradientTransform: "translate(-24.04 -43.96) rotate(26.66)",
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-75",
    x1: 101.23,
    y1: -614.02,
    x2: 103.18,
    y2: -614.02,
    gradientTransform: "translate(-104.05 -72.9) rotate(94.43)",
    xlinkHref: "#linear-gradient-17"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-19"
  }, /*#__PURE__*/React.createElement("g", {
    id: "OBJECTS"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M382.58,108.04c.04.05.09.1.13.16-.01,0-.02,0-.03,0-73.07,8.55-108.53-35.34-98.91-52.14,4.41-7.7,13.14-10.9,24.1-10.58.06,0,.11,0,.16,0,.09,0,.18,0,.27,0,.11,0,.22.01.33.01.03,0,.04,0,.04,0,14.76.64,33.38,7.48,50.89,18.13,4.17,2.54,8.28,5.29,12.26,8.23l2.57,8.65,6.22,20.92,1.97,6.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M382.58,108.04l-1.97-6.61-6.22-20.92-2.57-8.65c-3.98-2.94-8.09-5.69-12.26-8.23-13.85-8.42-28.39-14.45-41.16-16.93l-7.83,50.14c16.89,9.17,41.11,14.99,72.11,11.36.01,0,.02,0,.03,0-.04-.05-.09-.1-.13-.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M371.82,71.86c-3.98-2.94-8.09-5.69-12.26-8.23-17.51-10.65-36.14-17.49-50.89-18.13,0,0-.01,0-.04,0-.11,0-.22,0-.33-.01-.09,0-.18,0-.27,0-.05,0-.11,0-.16,0-5-.14-9.53.45-13.4,1.86l.51,2.65s8.07-6.02,27.7-1.05c18.8,4.76,41.15,19.6,50.01,25.85l-.87-2.92Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M433.03,90.35c-4.36,16.29-24.98,17.35-43.75,11.58-22.13.08-44.53-10.57-36.5-30.91,10.33-22.08,48.16-112.25,69.36-48.73,6.08,18.42,9.16,43,11.2,60.14.31,2.65.27,5.35-.32,7.92Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M419.81,16.01c-2.05.83-4.92,1.35-8.46,1.43-9.4.22-20.13-2.73-24.89-6.72.28-.33.56-.65.84-.97,5.06,3.73,15.31,6.43,24.32,6.22,3.1-.07,5.7-.48,7.68-1.14.17.39.34.78.51,1.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M418.64,13.38c-1.84.5-4.13.82-6.79.88-8.55.2-18.22-2.23-23.47-5.68.32-.34.63-.68.96-1,5.42,3.2,14.6,5.39,22.78,5.2,2.25-.05,4.23-.28,5.9-.66.21.41.41.83.61,1.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M417.27,10.67c-1.45.26-3.11.42-4.93.47-7.73.19-16.37-1.78-21.84-4.71.37-.35.74-.69,1.11-1.01,5.51,2.67,13.66,4.42,21,4.25,1.41-.03,2.72-.14,3.92-.3.25.42.5.86.74,1.31Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M432.13,93.18c-.36.86-.79,1.68-1.27,2.44-4.54,1.36-11.62,2-20.73,1.67-22.32-.81-48.42-7.17-58.57-14.25-.22-.87-.36-1.76-.43-2.68.12.07.23.16.36.25,10.03,7.18,36.47,13.66,59.08,14.48,9.65.35,17.05-.39,21.57-1.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M433.03,90.35c-4.41,1.68-12.04,2.52-22.16,2.15-22.5-.82-48.83-7.27-58.81-14.42-.32-.23-.63-.46-.91-.69.06-.68.17-1.37.31-2.08.24.15.5.31.77.5,10.02,7.18,36.47,13.67,59.08,14.49,10.03.36,17.62-.45,22.08-2.1-.08.74-.2,1.46-.36,2.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M433.54,85.76c-4.44,1.63-11.98,2.43-21.93,2.07-22.5-.82-48.83-7.27-58.81-14.42-.24-.18-.47-.35-.69-.52.2-.62.42-1.24.68-1.88.06.04.12.08.18.12,10.03,7.18,36.47,13.67,59.08,14.49,9.56.35,16.91-.38,21.43-1.87.05.69.07,1.35.06,2Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M411.37,57c8.83.19,15.14-.95,18.09-2.92-.41-2.49-.85-5-1.32-7.49-2.73,1.81-8.55,2.85-16.69,2.68-15.57-.33-33.71-4.99-40.52-10.4-.72-.57-1.28-1.12-1.69-1.66-1.21,2.23-2.39,4.49-3.55,6.74.45.58,1.05,1.18,1.83,1.8,7.37,5.86,27.01,10.9,43.86,11.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M427.07,41.18c-2.57,1.68-8.02,2.65-15.6,2.49-14.58-.31-31.58-4.67-37.96-9.75-.67-.53-1.19-1.05-1.58-1.55,1.23-2.18,2.49-4.32,3.76-6.39.35.45.82.91,1.42,1.39,5.77,4.58,21.12,8.52,34.29,8.8,6.81.15,11.71-.72,14.05-2.22.58,2.36,1.12,4.78,1.62,7.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M424.13,28.87c-2.17,1.36-6.65,2.14-12.86,2.01-12.1-.26-26.2-3.88-31.49-8.09-.54-.43-.97-.85-1.29-1.26,1.29-1.97,2.59-3.86,3.91-5.64.27.34.63.69,1.09,1.05,4.63,3.67,16.94,6.84,27.51,7.06,5.36.11,9.23-.55,11.16-1.71.7,2.1,1.36,4.3,1.98,6.58Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M360.76,69.35c-.45-.31-.88-.62-1.28-.94-.17-.14-.34-.27-.5-.41-1.04-.89-1.77-1.76-2.21-2.58,2.49-3.67,2.64-3.89,4.42-6.42.74-1.03,1.71-2.41,2.45-3.44.78-1.07,1.81-2.49,2.59-3.56-.36,1.43-.85,3.33-1.18,4.77-.29,1.42-.7,3.3-.95,4.73-.86,5.47-.91,5.8-1.21,9.17-.77-.43-1.48-.87-2.14-1.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M375.94,75.94c-1.15-.35-2.27-.71-3.36-1.08-2.17-.74-4.19-1.53-6.02-2.36,3.31-3.93,3.51-4.17,5.69-6.92.87-1.12,2.03-2.61,2.89-3.74.87-1.17,2.03-2.72,2.89-3.89.01,1.47,0,3.43.04,4.9.07,1.45.15,3.38.26,4.83.54,5.56.57,5.89,1.15,9.27-1.21-.32-2.39-.66-3.54-1.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M396.69,80.3c-1.34-.17-2.67-.36-4-.57-2.65-.42-5.27-.92-7.82-1.48,3.25-4.37,3.45-4.63,5.47-7.67.79-1.24,1.85-2.88,2.62-4.13.76-1.28,1.78-2.99,2.52-4.28.32,1.46.73,3.4,1.08,4.85.37,1.42.84,3.33,1.24,4.74,1.59,5.31,1.72,5.75,2.92,8.99-1.34-.13-2.68-.28-4.02-.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M417.49,81.15c-1.08.08-2.22.13-3.4.16-1.39.03-2.85.04-4.37,0-1.07-.02-2.16-.06-3.25-.12,2.47-4.71,2.73-5.21,4.16-8.47.55-1.35,1.3-3.15,1.81-4.52.48-1.4,1.15-3.25,1.6-4.66.48,1.37,1.12,3.21,1.61,4.58.49,1.33,1.14,3.11,1.64,4.44,1.9,4.93,2.06,5.33,3.29,8.3-.98.12-2.01.22-3.09.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-48",
    d: "M362.19,53.46c-.71,1.37-1.38,2.25-1.47,1.91-.18-.66,2.49-6.09,2.83-5.75.01.01.02.03.02.05.06.55-.68,2.44-1.37,3.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "M370.7,59.95c-.88,1.98-2.36,2.77-2.88,1.53-.72-1.7,1.21-6.17,2.87-5.56.95.62.57,2.77.01,4.03h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M387.34,65.28c-.69,2.34-2.74,3.21-3.67,1.56-1.06-1.89.41-5.88,2.54-5.56,1.43.47,1.52,2.67,1.13,4h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M407.13,68c-.29,2.46-2.2,3.63-3.47,2.14-1.44-1.7-.63-5.87,1.62-5.9,1.55.24,2.01,2.34,1.85,3.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M430.21,78.12c-.45.28-.97.55-1.55.8-1.16.5-2.56.94-4.19,1.29,1-5.22,1.06-5.53,1.49-9.09.14-1.43.35-3.34.46-4.78.08-1.46.21-3.41.26-4.88.39,1.26.92,2.94,1.31,4.2.37,1.21.86,2.83,1.23,4.05,1.29,4.38,1.43,4.84,2.17,7.5-.33.31-.72.61-1.17.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M422.82,67.25c.09,2.35-.91,3.83-1.94,2.86-1.3-1.21-1.35-5.78.29-6.24,1.11-.04,1.6,2.05,1.65,3.37h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M430.52,63.29c.3,2.13.28,3.61-.05,3.37-.64-.46-1.27-5.43-.8-6.33.38-.35.83,2.83.85,2.96h0Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M410.27,2.25c-2.47-1.76-5.02-2.43-7.62-2.21-19.76,10.63-40.39,59.16-47.84,75.09-1.79,4.53-2.18,8.62-1.48,12.25,2.54,4.39,7.08,7.8,12.7,10.22-3.17-21.7,18.74-87.52,44.24-95.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M430.36,59.75l-67.38-10.52c-4.4,8.96-7.94,16.99-10.19,21.79-8.03,20.34,14.36,30.99,36.5,30.91,18.77,5.77,39.39,4.71,43.75-11.58.59-2.56.63-5.27.32-7.92-.8-6.7-1.76-14.53-2.99-22.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M433.35,82.43c-2.05-17.14-5.12-41.72-11.2-60.14-5.86-17.57-13-23.38-20.47-22.12l-15.88,101.68c1.16.05,2.33.08,3.49.08,18.77,5.77,39.39,4.71,43.75-11.58.59-2.56.63-5.27.32-7.92Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M488.54,99.96c-.09.12-.17.26-.29.35-40.77,32.37-85.26,25.92-105.55,7.89,7.32-.86,14.24-2.02,20.79-3.38,7.78-1.61,15.03-3.5,21.83-5.49,19.8-5.83,35.65-12.57,48.75-16,27.3-7.13,23.23,5.6,14.47,16.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M488.54,99.96c-.09.12-.17.26-.29.35-40.77,32.37-85.26,25.92-105.55,7.89,7.32-.86,14.24-2.02,20.79-3.38,7.78-1.61,15.03-3.5,21.83-5.49,19.8-5.83,35.65-12.57,48.75-16,27.3-7.13,23.23,5.6,14.47,16.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M458.96,88.06c-9.79,3.38-20.89,7.51-33.63,11.26-6.79,1.99-14.05,3.89-21.83,5.49-6.55,1.36-13.48,2.52-20.79,3.38,14.67,13.05,42.01,20.02,71.44,10.64l4.81-30.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M380.4,138.87h-10.36c-.97,0-1.75-.78-1.75-1.75v-36.89h12.12v38.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M401.46,109.37h-16.64v-9.14h45.55v9.14h-16.69v29.5h-10.47c-.97,0-1.75-.78-1.75-1.75v-27.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M363.2,109v-8.78h-26.84l-13.14,13.12v23.77c0,.97.78,1.75,1.75,1.75h10.31v-15.32h27.24v-8.83h-27.24v-5.72h27.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M488.54,99.96c8.76-11.03,12.83-23.76-14.47-16.63-21.38,5.58-50.09,20.03-91.36,24.87-.01,0-.02,0-.03,0-73.07,8.55-108.53-35.34-98.91-52.14,4.39-7.67,13.06-10.87,23.95-10.58-3.29,0-14.08.74-15.59,10.44-1.66,10.66,15.75,20.11,31.37,23.78,16.27,3.82,33.68,3.36,50.89.81,39.95-5.9,78.86-22.97,100.19-23.6,39.74-1.17,33.14,24.03,13.96,43.05Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M292.2,55.46c-.01.09-.02.17-.03.26,1.64-9.51,12.29-10.24,15.55-10.24-1.89-.05-3.71,0-5.45.17-4.21,1-9.09,3.52-10.07,9.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M489.86,98.23c-.43.58-.87,1.16-1.32,1.73,8.1-8.04,13.96-17.18,15.02-24.97-1.16,7.28-6.4,15.68-13.7,23.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M495.05,87.7c1.06-5.91-3.66-9.33-20.91-4.83-21.38,5.58-50.09,20.03-91.36,24.87-.01,0-.02,0-.03,0-67.3,7.88-102.7-28.74-100.35-47.69-2.99,18.82,32.43,56.1,100.27,48.15.01,0,.02,0,.03,0,41.28-4.85,69.98-19.29,91.36-24.87,16.79-4.38,21.71-1.25,20.98,4.37Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-55",
    d: "M488.54,99.96c4.81-6.05,8.2-12.61,5.78-16.12,1.24-8.85,5.55-17.32-12.28-15.15-15.36,1.88-30.64,7.85-45.03,12.47-24.63,7.71-49.46,15.02-75.49,16.14-22.07.59-45.98-2.87-64.07-15.67-19.64-14.39-18.73-37.02,10.26-36.14-3.29,0-14.08.74-15.59,10.44-1.66,10.66,15.75,20.11,31.37,23.78,23.3,6.72,53.8,2.17,82.46-5.14,27.35-6.98,53.03-16.56,68.61-17.65,39.74-1.17,33.14,24.03,13.97,43.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M495.3,88.07c1.4-3.85,2.36-7.88,2.46-11.77.05-1.94-.17-3.83-.74-5.45-.29-.8-.67-1.52-1.13-2.13-.47-.6-1.01-1.09-1.63-1.47-1.24-.76-2.83-1.11-4.58-1.15h-.66c-.22,0-.5.02-.75.03l-1.53.06-3.06.11c-1.02.06-2.02.17-3.03.25l-1.51.13c-.25.02-.51.04-.75.07l-.75.11-2.99.42-.75.11-.74.14-1.47.29c-1.97.34-3.91.87-5.86,1.34-.97.25-1.94.56-2.91.83l-1.46.42c-.49.14-.97.32-1.46.47l-2.92.95c-.97.32-1.96.67-2.93,1.01-1.95.67-3.93,1.37-5.9,2.07-3.95,1.39-7.94,2.78-11.96,4.11-2,.69-4.03,1.3-6.04,1.95-2.02.65-4.05,1.26-6.08,1.86-2.04.59-4.06,1.22-6.11,1.77l-6.13,1.67c-2.04.56-4.11,1.04-6.16,1.56l-3.08.76c-1.03.26-2.05.51-3.09.73l-6.19,1.39c-2.07.46-4.11.93-6.25,1.34-4.24.85-8.51,1.5-12.8,2.02-4.3.51-8.61.83-12.94.98-2.17.07-4.33.1-6.5.07-2.17-.02-4.33-.09-6.5-.21-4.33-.24-8.65-.69-12.95-1.36-4.3-.67-8.57-1.58-12.77-2.74-4.21-1.18-8.36-2.61-12.39-4.4-4.02-1.8-7.93-3.93-11.55-6.6-1.81-1.33-3.55-2.79-5.14-4.43-1.6-1.64-3.07-3.44-4.28-5.46-.61-1.01-1.15-2.06-1.59-3.17-.44-1.11-.82-2.25-1.04-3.44-.23-1.19-.35-2.39-.34-3.59l.05-.9c.02-.3.03-.6.08-.9.1-.6.16-1.2.34-1.79.27-1.19.78-2.33,1.39-3.39.62-1.06,1.44-1.98,2.3-2.79,1.06-.95,2.3-1.82,3.58-2.51.67-.25,1.35-.48,2.06-.68,3.43-1,7.31-1.41,11.52-1.3-3.29,0-14.08.74-15.59,10.44-1.66,10.66,15.75,20.11,31.37,23.78,16.27,3.82,33.68,3.36,50.89.81,39.95-5.9,78.86-22.97,100.19-23.6,39.74-1.17,33.14,24.03,13.96,43.05.54-.68,1.07-1.37,1.56-2.06,0-.01.01-.02.02-.03,2.27-3.14,4.04-6.31,4.71-9.02.21-.25.37-.5.47-.78Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M307.72,45.48c-.08,0-.16,0-.24,0,.08,0,.17,0,.24,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M307.25,45.48c.08,0,.15,0,.23,0,.08,0,.17,0,.24,0-.15,0-.3,0-.46,0,0,0,0,0-.01.01,0,0,0,0,0,0Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M474.57,56.9c-11.29.34-27.52,5.28-46.23,10.74-16.61,4.85-35.17,10.09-53.96,12.87-6.89,1.02-13.81,1.7-20.67,1.91-10.29.32-20.46-.43-30.22-2.72-15.62-3.67-33.04-13.12-31.37-23.78,1.52-9.7,12.3-10.44,15.59-10.44-.97-.03-1.92-.02-2.86,0-5.3.82-10.18,2.86-12.36,7.3-1.52,3.1-2.79,8.35,1.46,12.96,26.83,29.15,86.25,21.63,155.67-1.23,36.18-11.91,50.94-3.3,52.8,5.58,2.66,12.71-12.9,28.78-13.51,29.47,18.87-18.98,25.11-43.82-14.36-42.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M422.97,24.9c-.27-.88-.54-1.75-.83-2.61-18.25-54.71-48.86,4.6-63.59,36.2,26.33.93,50.61-12.32,64.42-33.6Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "M286.87,56.14c.91-1.07,1.95-1.92,2.93-2.58l.75-.46c.25-.14.51-.26.75-.38.12-.06.24-.12.36-.18l.37-.15c.25-.09.46-.21.71-.28.22-1.06.72-2.08,1.38-3.01.66-.93,1.5-1.72,2.42-2.39-2.1.65-4.2,1.67-5.98,3.26-.87.81-1.69,1.72-2.3,2.79-.61,1.06-1.12,2.2-1.39,3.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "M289.36,69.93c.26-3,.93-5.67,1.89-7.75-1.03-.66-1.95-1.52-2.71-2.54-.18-.26-.35-.52-.52-.79-.16-.27-.35-.56-.47-.85-.26-.59-.54-1.21-.68-1.86-.18.59-.24,1.19-.34,1.79-.06.3-.06.6-.08.9l-.05.9c-.01,1.2.1,2.41.33,3.6.22,1.19.6,2.33,1.04,3.44.44,1.11.98,2.17,1.59,3.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "M298.78,79.82c-.58-3.16-.95-6.12-1.05-8.81-2.82.23-5.68-.05-8.37-1.07,1.21,2.02,2.68,3.82,4.28,5.46,1.6,1.64,3.34,3.09,5.14,4.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "M310.33,86.42c-1.06-3.26-1.95-6.38-2.66-9.33-2.88,1.29-5.86,2.23-8.89,2.73,3.62,2.67,7.53,4.8,11.56,6.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "M322.72,90.82c-1.42-3.34-2.7-6.58-3.81-9.69-2.75,2.04-5.61,3.82-8.57,5.29,4.03,1.79,8.18,3.22,12.39,4.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-57",
    d: "M335.49,93.56c-1.75-3.37-3.35-6.69-4.8-9.91-2.53,2.6-5.2,5-7.98,7.17,4.21,1.17,8.48,2.07,12.77,2.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M348.44,94.92c-2.04-3.36-3.94-6.7-5.7-9.98-2.28,3.04-4.7,5.91-7.25,8.62,4.3.67,8.62,1.12,12.95,1.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M361.44,95.06c-2.32-3.31-4.5-6.6-6.55-9.89-2.01,3.36-4.16,6.63-6.45,9.75,2.17.13,4.33.19,6.5.21,2.17.03,4.33,0,6.5-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M374.38,94.08c-2.58-3.19-5.02-6.4-7.34-9.63-1.73,3.63-3.59,7.15-5.6,10.61,4.33-.15,8.65-.47,12.94-.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M387.18,92.06c-1.4-1.51-2.78-3.04-4.12-4.57-1.35-1.55-2.66-3.08-3.94-4.64-.72,1.89-1.48,3.78-2.27,5.65-.79,1.88-1.61,3.73-2.47,5.58,4.29-.51,8.57-1.17,12.8-2.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M399.62,89.33c-2.85-2.95-5.67-5.92-8.45-8.91-1.29,3.89-2.55,7.78-3.98,11.64,2.14-.42,4.18-.89,6.25-1.34l6.19-1.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M411.95,86.27c-1.45-1.39-2.9-2.83-4.33-4.27-1.44-1.44-2.87-2.89-4.29-4.35l-1.82,5.83c-.62,1.95-1.24,3.91-1.88,5.85,1.03-.22,2.06-.48,3.09-.74l3.08-.76c2.05-.52,4.11-1,6.16-1.56Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M424.19,82.84c-2.95-2.66-5.87-5.34-8.77-8.16-1.12,3.82-2.28,7.68-3.47,11.59l6.13-1.67c2.05-.54,4.07-1.18,6.11-1.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M436.31,79.03c-2.96-2.41-5.94-4.98-8.88-7.58-1.05,3.75-2.13,7.54-3.25,11.38,2.03-.6,4.06-1.2,6.08-1.86,2.02-.65,4.05-1.27,6.05-1.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M448.27,74.92c-2.92-2.21-5.89-4.53-8.85-6.93-1.03,3.6-2.06,7.28-3.1,11.04,4.02-1.33,8-2.72,11.95-4.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M460.02,70.89l-4.18-3.2-4.33-3.28c-1.16,3.39-2.21,6.9-3.24,10.51,1.97-.7,3.95-1.4,5.9-2.07.98-.34,1.96-.69,2.93-1.01l2.92-.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "M471.71,67.82c-2.36-2.17-4.9-4.27-7.66-6.52-.78,1.51-1.48,3.11-2.15,4.69-.67,1.59-1.29,3.2-1.88,4.9.49-.15.97-.33,1.46-.47l1.46-.42c.97-.28,1.94-.59,2.92-.83,1.95-.47,3.89-1.01,5.86-1.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "M483.7,66.31l-3.19-3.17-1.68-1.68c-.28-.28-.57-.58-.86-.86l-.88-.83c-1,1.24-1.95,2.53-2.85,3.85l-.67,1-.64,1.05c-.42.71-.83,1.42-1.22,2.14l1.47-.29.74-.15.74-.1,2.98-.42.75-.11c.25-.03.5-.05.75-.07l1.51-.13c1.01-.08,2.02-.19,3.03-.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-67",
    d: "M494.27,67.26c-.1-1.1-.53-2.33-1.25-3.55-.72-1.22-1.7-2.42-2.84-3.56-.32.21-.64.44-.94.66-.3.23-.56.48-.83.72-.54.49-1.08,1-1.61,1.52-1.06,1.04-2.1,2.12-3.1,3.25l3.06-.11,1.53-.06c.25,0,.53-.03.75-.03h.66c1.74.04,3.34.39,4.57,1.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-61",
    d: "M497.77,76.3c.66-.91,1.34-1.88,1.99-2.97.64-1.09,1.26-2.3,1.73-3.72-1.02-1.01-2.23-1.82-3.5-2.24-1.28-.42-2.57-.46-3.72-.11.63.37,1.16.87,1.63,1.47.46.61.84,1.32,1.13,2.13.57,1.61.78,3.51.74,5.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-62",
    d: "M495.3,88.07c1.35-1.64,2.91-3.25,4.63-5.02-.22-2.33-.92-4.7-2.17-6.76-.1,3.9-1.06,7.93-2.46,11.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "M489.27,98.87c1.42-1.55,3.44-4.52,5.08-6,.99-1.9.89-2.58.95-4.8-.71,1.93-1.54,3.82-2.52,5.65-.99,1.82-2.09,3.59-3.51,5.15Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-64",
    d: "M337.66,88.03c-.14.92-1.01,1.55-1.93,1.41-.92-.14-1.55-1.01-1.41-1.93.14-.92,1.01-1.55,1.93-1.41.92.14,1.55,1.01,1.41,1.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "M325.74,85.69c-.13.82-.89,1.37-1.71,1.25-.82-.13-1.37-.89-1.25-1.71s.89-1.37,1.71-1.25c.82.13,1.37.89,1.25,1.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-59",
    d: "M313.63,81.93c-.13.82-.9,1.38-1.71,1.25s-1.38-.9-1.25-1.71c.13-.82.9-1.38,1.71-1.25.82.13,1.38.9,1.25,1.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "M302.64,76.04c-.1.67-.73,1.12-1.39,1.02-.67-.1-1.12-.73-1.02-1.39.1-.67.73-1.12,1.39-1.02.67.1,1.12.73,1.02,1.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-75",
    d: "M293.72,67.89c-.11.72-.79,1.21-1.51,1.1-.72-.11-1.21-.79-1.1-1.51s.79-1.21,1.51-1.1,1.21.79,1.1,1.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-76",
    d: "M290.29,57.29c-.08.52-.56.87-1.08.79-.52-.08-.87-.56-.79-1.08s.56-.87,1.08-.79c.52.08.87.56.79,1.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "M350.28,89c-.14.92-1.01,1.55-1.93,1.41-.92-.14-1.55-1.01-1.41-1.93.14-.92,1.01-1.55,1.93-1.41.92.14,1.55,1.01,1.41,1.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-71",
    d: "M362.79,88.88c-.14.92-1.01,1.55-1.93,1.41-.92-.14-1.55-1.01-1.41-1.93.14-.92,1.01-1.55,1.93-1.41.92.14,1.55,1.01,1.41,1.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "M375.55,87.75c-.14.92-1.01,1.55-1.93,1.41-.92-.14-1.55-1.01-1.41-1.93.14-.92,1.01-1.55,1.93-1.41.92.14,1.55,1.01,1.41,1.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-73",
    d: "M387.63,85.89c-.14.92-1.01,1.55-1.93,1.41-.92-.14-1.55-1.01-1.41-1.93.14-.92,1.01-1.55,1.93-1.41.92.14,1.55,1.01,1.41,1.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-74",
    d: "M399.88,83.19c-.14.92-1.01,1.55-1.93,1.41-.92-.14-1.55-1.01-1.41-1.93.14-.92,1.01-1.55,1.93-1.41.92.14,1.55,1.01,1.41,1.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-68",
    d: "M411.93,80.48c-.14.92-1.01,1.55-1.93,1.41-.92-.14-1.55-1.01-1.41-1.93.14-.92,1.01-1.55,1.93-1.41.92.14,1.55,1.01,1.41,1.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "M424.35,77.33c-.14.92-1.01,1.55-1.93,1.41-.92-.14-1.55-1.01-1.41-1.93.14-.92,1.01-1.55,1.93-1.41.92.14,1.55,1.01,1.41,1.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "M436.04,73.69c-.14.92-1.01,1.55-1.93,1.41-.92-.14-1.55-1.01-1.41-1.93.14-.92,1.01-1.55,1.93-1.41.92.14,1.55,1.01,1.41,1.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-83",
    d: "M448.29,70.02c-.14.92-1.01,1.55-1.93,1.41-.92-.14-1.55-1.01-1.41-1.93.14-.92,1.01-1.55,1.93-1.41.92.14,1.55,1.01,1.41,1.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-81",
    d: "M460.11,66.11c-.14.92-1.01,1.55-1.93,1.41-.92-.14-1.55-1.01-1.41-1.93.14-.92,1.01-1.55,1.93-1.41.92.14,1.55,1.01,1.41,1.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-79",
    d: "M472.59,63.29c-.14.92-1.01,1.55-1.93,1.41-.92-.14-1.55-1.01-1.41-1.93.14-.92,1.01-1.55,1.93-1.41.92.14,1.55,1.01,1.41,1.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-82",
    d: "M484.63,62.12c-.14.92-.86,1.57-1.59,1.46-.74-.12-1.22-.96-1.07-1.88.14-.92.86-1.57,1.59-1.46.74.12,1.22.96,1.07,1.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-80",
    d: "M496.86,65.23c-.3.6-.94.89-1.42.65-.48-.24-.63-.92-.32-1.53.3-.6.94-.89,1.42-.65.48.24.63.92.32,1.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-78",
    d: "M500.18,77.43c-.67-.05-1.18-.53-1.14-1.07.04-.54.62-.93,1.29-.88.67.05,1.18.53,1.14,1.07-.04.54-.62.93-1.29.88Z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M291.66,99.55c24.33,0,27.19,12.21,27.19,19.12v1.56c0,6.8-2.81,19.33-27.19,19.33h-2.24c-24.49,0-27.24-12.52-27.24-19.33v-1.56c0-6.91,2.75-19.12,27.24-19.12h2.24ZM306.16,119.03c0-4.41-2.55-10.13-15.65-10.13s-15.65,5.72-15.65,10.13v.63c0,4.41,2.55,10.49,15.65,10.49s15.65-5.92,15.65-10.39v-.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M258.96,133.89v-5.66c0-4.99-3.38-7.74-7.33-8.88,2.55-.83,7.18-2.91,7.18-8.47v-.63c0-5.56-3.9-10.02-16.79-10.02h-17.91l-13.28,13.27v23.63c0,.97.78,1.75,1.75,1.75h10.36v-13.71h15.81c5.98,0,8.06,2.08,8.06,6.8v4.47c0,1.4.21,1.97.57,2.44h12.33v-.26c-.38-.61-.74-1.6-.74-4.72ZM246.17,112.79c0,2.13-1.4,3.79-4.89,3.79h-18.35v-7.58h18.35c3.54,0,4.89,1.71,4.89,3.74v.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M188.77,100.22h-15.76l-13.26,13.24v23.65c0,.97.78,1.75,1.75,1.75h10.36v-12.88h16.9c13.83,0,18.04-5.77,18.04-12.68v-.52c0-7.06-4.1-12.57-18.04-12.57ZM194.18,113.26c0,2.65-1.82,4.05-5.62,4.05h-16.69v-8.31h16.69c3.9,0,5.62,1.45,5.62,4.11v.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M74.49,100.57h-15.3l-10.34,10.33v26.57c0,.97.78,1.75,1.75,1.75h23.93c22.17,0,27.05-10.08,27.23-18.31l-19.95-19.93c-2.21-.26-4.64-.4-7.33-.4ZM89.1,119.63v.31c0,3.95-1.82,9.97-15.55,9.97h-12.58v-20.21h12.58c13.94,0,15.55,5.98,15.55,9.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M118.06,129.61v-29.04h-12.12v24.5l14.16,14.15h24.84v-9.61h-26.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M29.01,100.57h-15.71L0,113.85v25.36h12.12v-12.88h16.9c1.69,0,3.23-.09,4.65-.25l13.38-13.37c-.17-6.86-4.39-12.15-18.03-12.15ZM34.42,113.6c0,2.65-1.82,4.05-5.62,4.05H12.11v-8.31h16.69c3.9,0,5.62,1.45,5.62,4.11v.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M74.49,100.57h-15.3l-10.34,10.33v26.57c0,.97.78,1.75,1.75,1.75h23.93c22.17,0,27.05-10.08,27.23-18.31l-19.95-19.93c-2.21-.26-4.64-.4-7.33-.4ZM89.1,119.63v.31c0,3.95-1.82,9.97-15.55,9.97h-12.58v-20.21h12.58c13.94,0,15.55,5.98,15.55,9.93Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoPdlMx);
export default __webpack_public_path__ + "homepage/static/media/logo-pdl_mx.ab27b347f62aaca593aac39fcff00f26.svg";
export { ForwardRef as ReactComponent };